import * as React from 'react';
import Link from 'next/link';
import { AccaRouteUrl } from '@utils/routeUtil';
import classNames from 'classnames/bind';
import styles from './gameLink.module.scss';

const cx = classNames.bind(styles);

const GameLink = () => {
  return (
    <div className={cx('gameLinkArea')}>
      <div className={cx('gameLinkText')}>
        응시 과정 피드백을 잘 확인하셨나요?
        <br />
        보완하고 싶다면 튜토리얼을 통해 연습해보세요!
      </div>
      <Link href={AccaRouteUrl.ACCA_TUTORIAL} legacyBehavior>
        <a className={cx('btnTutorial')} role="button">
          튜토리얼 바로가기
        </a>
      </Link>
    </div>
  );
};

export default GameLink;
